import productDetailStore from './productDetail/productDetail';
import productEbsStore from './productEbs/productEbs';

export default {
    productDetailStore,
    productEbsStore
};
